import s from "./firstStep.module.css";
import {useFirstStep} from "./useFirstStep";
import RadioInput from "./RadioInput";
import {useAppContext} from "../../../../../contexts";

const FirstStep = (props) => {
    // Destructured props
    const {
        formValues,
        handleChange,
        surveyData
    } = props;

    // Component logic data
    // const componentProps = useFirstStep();

    // Destructured component logic data
    // const {} = componentProps;

    // All the available inputs
    const inputs = surveyData.ratings.map((item) => {
        return (
            <RadioInput
                key={item}
                formValues={formValues}
                handleChange={handleChange}
                item={item}
            />
        )
    });

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <div className={"pr-0 md:pr-20"}>
            <h1 className={`${s.heading} ${highContrast ? "!text-white" : ""}`}>
                Em uma escala de 1 a 5, como foi a sua experiência ao realizar compras em nossa Loja Virtual?
            </h1>
            <div className={"flex flex-row justify-between w-full md:w-5/6 mt-3"}>
                {inputs}
            </div>
        </div>
    )
}

export default FirstStep;
